import { default as cs } from "../translations/cs-CZ.json";
import { default as da } from "../translations/da.json";
import { default as ds } from "../translations/de.json";
import { default as en } from "../translations/en.json";
import { default as es } from "../translations/es-MX.json";
import { default as fi } from "../translations/fi.json";
import { default as fr } from "../translations/fr.json";
import { default as hi } from "../translations/hi-IN.json";
import { default as hu } from "../translations/hu-HU.json";
import { default as it } from "../translations/it.json";
import { default as ja } from "../translations/ja.json";
import { default as ko } from "../translations/ko.json";
import { default as lt } from "../translations/lt.json";
import { default as uk } from "../translations/uk.json";
import { default as mr } from "../translations/mr.json";
import { default as ms } from "../translations/ms-MY.json";
import { default as nb } from "../translations/nb-NO.json";
import { default as nn } from "../translations/nb-NO.json";
import { default as no } from "../translations/nb-NO.json";
import { default as nl } from "../translations/nl.json";
import { default as nlIN } from "../translations/nl-IN.json";
import { default as pl } from "../translations/pl-PL.json";
import { default as pt } from "../translations/pt.json";
import { default as ru } from "../translations/ru-RU.json";
import { default as sk } from "../translations/sk-SK.json";
import { default as sv } from "../translations/sv-SE.json";
import { default as th } from "../translations/th-TH.json";
import { default as tr } from "../translations/tr-TR.json";
import { default as vi } from "../translations/vi-VN.json";
import { default as zh } from "../translations/zh-CN.json";
import { default as de } from "../translations/de.json";
import { default as lv } from "../translations/lv.json";



export const getLanguage = language => {
  const langs = {
    cs: cs,
    da: da,
    de: de,
    ds: ds,
    en: en,
    "en-US": en,
    es: es,
    fi: fi,
    fr: fr,
    hi: hi,
    hu: hu,
    it: it,
    ja: ja,
    ko: ko,
    lt: lt,
    uk: uk,
    mr: mr,
    ms: ms,
    nb: nb,
    nn: nn,
    no: no,
    nl: nl,
    'nl-IN': nlIN,
    pl: pl,
    pt: pt,
    ru: ru,
    sk: sk,
    sv: sv,
    th: th,
    tr: tr,
    vi: vi,
    lv: lv,
    zh: zh
  };

  return langs[language];
};
